import { object } from "../helpers/object";
import { debug } from "../helpers/debug";

/*------------------------------------*\
  #LINK

  Gestion de fake link pour des raison SEO

  [data-js-trigger="link"]
  [data-js-link="{string}"] // lien de remplacement
\*------------------------------------*/
class Link {


  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT
    document.addEventListener('click', this.clickHandler);
    if(debug.DEBUG) console.log('components/link.js');
  };

  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    const link = event.target.getAttribute('data-js-link');
    if (link) {
      window.open(link);
    } else if (event.target.matches('.tc-open-privacy-center')) {
      event.preventDefault();
      event.stopPropagation();
      tC.privacyCenter.showPrivacyCenter();
      return false
    }
  }
  
}
export const link = new Link('[data-js-link], .tc-open-privacy-center'); 